import { render, staticRenderFns } from "./share-form.vue?vue&type=template&id=6ef58bda&"
import script from "./share-form.vue?vue&type=script&lang=js&"
export * from "./share-form.vue?vue&type=script&lang=js&"
import style0 from "./share-form.vue?vue&type=style&index=0&id=6ef58bda&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports